import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import qrScanning from './StudentList/qrScanning'
import listExport from "./StudentList/exportList";
import ModalWindow from "./ModalWindow";
import ModalButton from "./ModalButton";
import StudentListTable from "./StudentListTable";
import data from "../api/databaseApi";
import { useCallback } from "react";

const StudentList = () =>{
    const navigate = useNavigate();
    const {classid} = useParams();
    const [studentList,setStudentList ]= useState([]);
    const [checkedStudents, setChecks ] = useState([]);
    const [semesterName, setSemesterName] = useState('');
    const [className, setClassName] = useState('');
    const [uploadedFile, setUploadedFile] = useState();
    const [fileSelected, setFileSelected ]= useState(false);
    const [lastFileEventTarget, setEventTarget] = useState(null);
    const handleSubmission = (e) =>{
        e.preventDefault();
        if(fileSelected === false){
            return;
        }
        if(uploadedFile.type === 'text/csv'){
            var reader = new FileReader()
            reader.readAsText(uploadedFile,"UTF-8");
            reader.onload = function (evt){
                let textOutput = evt.target.result
                let file = textOutput.split('\n')
                for(const lines in file){
                    file[lines] = file[lines].split(',');
                }
                if(file[file.length-1].length === 1){
                    file.pop(file.length-1);
                }
                getResults(file);
            }
            reader.onerror = function (evt) {
                console.log("Error reading file");
            }
        }else{
            console.log("Invalid input");
        }
        clearFile();
    }

    const clearFile = () =>{
        if(lastFileEventTarget !== null){
            lastFileEventTarget.value = null;
            setEventTarget(null)
        }
        setFileSelected(null)
        setUploadedFile();
    }

    const getStudents = async () =>{
        return await data.getStudents(classid);
    }
    const getStudentsCallBack = useCallback(getStudents,[classid]);
    useEffect(() =>{
        const update = async () =>{
            const data2 = await data.getClass(classid);
            const data1 = await data.getSemester(data2.semesterId);
            setSemesterName(data1.name);
            setClassName(data2.name);
            const students = await getStudentsCallBack();
            let checks = []
            for(var i = 0;i < students.length;i++){
                checks.push(false);
            }
            setChecks(checks);
            setStudentList(students);
        }
        update();
    },[classid,getStudentsCallBack])
    const addStudent = async (newStudent) =>{
        const studentValue = await data.addStudent(newStudent,classid);
        setStudentList([...studentList,studentValue]);
    }
    const removeStudent = async (studentIdToRemove) =>{
        data.removeStudent(studentIdToRemove);
        setStudentList(studentList.filter((student) =>{
            if(student.id !== studentIdToRemove){
                return student
            }
            return null
        }))
    }
    const getResults = (resultTable)=>{
        const sendResults = async (students, index, size) =>{
            if(index >= size){
                const students = await getStudents();
                setStudentList(students);
                return;
            }
            data.addStudent({name:students[index][0],email:students[index][1]},classid)
            .then(() =>{
                sendResults(students,index+1,size);
            })
        }
        sendResults(resultTable,0,resultTable.length);
    }

    return (
        <div className="container">
            <div className="container">
                <div className="row">
                    <button className="col btn btn-light border border-1" onClick={()=>{navigate(-1)}}>Back</button>
                    <ModalButton modalId='importStudents' className='col p-0' element={(<button className="btn btn-light border border-1 w-100 h-100 m-0">Import Students</button>)}/>
                    <ModalButton onClick={(e)=>{e.preventDefault();qrScanning.openScanner(studentList, setStudentList)}} modalId='scan-students' className='col p-0' element={(<button className="btn btn-light border border-1 w-100 m-0">Scan QR Codes</button>)}/>
                    <button className="col btn btn-light border border-1" onClick={()=> {listExport.generate(studentList,`${className} - ${semesterName}`);}}>Export Record</button><div id='download-export' className="d-none"></div>
                </div>
            </div>
            <StudentListTable 
                className={className}
                semesterName={semesterName}
                studentList={studentList}
                removeStudent={removeStudent}
                setChecks={setChecks}
                checkedStudents={checkedStudents}
                addStudent={addStudent}
            />
            <ModalWindow 
                id="importStudents" 
                title="Import Students" 
                saveButtonMsg="Save" 
                onSubmit={handleSubmission} 
                onClose={(e) =>{
                    e.preventDefault();
                    if(lastFileEventTarget !== null){
                        lastFileEventTarget.value = null;
                        setEventTarget(null)
                    }
                }} 
                element={(
                    <>
                        <label htmlFor="formFile" className="form-label">Please Select A CSV File containing the names of the students you wish to add.</label>
                        <input 
                            type="file" 
                            id="formFile"
                            className="form-control"
                            onChange={(e) => {
                                setEventTarget(e.target);
                                setUploadedFile(e.target.files[0]);
                                setFileSelected(true);
                            }} 
                        />
                    </>
                )}
            />
            <ModalWindow 
                id="scan-students" 
                title="Scan QR Codes" 
                saveButtonMsg="Save"
                onClose={qrScanning.closeScanner}
                onSubmit={qrScanning.closeScanner}
                element={(
                    <>
                        <div id="reader" width="600px"></div>
                    </>
                )}
            />
        </div>
    )
}

export default StudentList